// Sort an array of users alphabetically by forenames, then surname as a tiebreaker.
// Users without a forenames value are placed at the end.
// When `descending` is true (default), Z comes before A.
export const sortByUserName = (users, descending = true) => {
  if (!users) return [];
  return [...users].sort((a, b) => {
    const aName = a?.forenames?.toLowerCase() ?? "";
    const bName = b?.forenames?.toLowerCase() ?? "";
    if (!aName && !bName) return 0;
    if (!aName) return 1;
    if (!bName) return -1;
    if (aName < bName) return descending ? 1 : -1;
    if (aName > bName) return descending ? -1 : 1;
    // Sort by surname when forenames match
    const aSurname = a?.surname?.toLowerCase() ?? "";
    const bSurname = b?.surname?.toLowerCase() ?? "";
    if (aSurname < bSurname) return descending ? 1 : -1;
    if (aSurname > bSurname) return descending ? -1 : 1;
    return 0;
  });
};
